export default {"src":"/_next/static/media/adapted-processes.d277d7ef.svg","height":84,"width":85};